import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Row, Col, Card} from 'antd';

import * as mapActions from '../actions/map-actions';
import NationalMap from "../charts/NationalMap";
import ScatterPlot from '../charts/ScatterPlot';

import ReadMore from '../components/ReadMore.js';
import CardMenu from './CardMenu.js';

import './NationalCard.css';

class NationalCard extends Component {
  render() {

    const selectState = this.props.actions.selectState;

    const title = <CardMenu showLocations={true} showDimensions={true} title="National Opioid Statistics"/>;

    return (
      <Card className="NationalCard" title={title} noHovering={true} loading={this.props.loading}>
        <Row gutter={35}>
          <Col xs={24} md={6} xl={5}>
            <p><b>Developing a Plan:</b><br/>
              Understanding geographic relationships between prescriptions and overdose deaths can help identify hard
              hit areas. This national map enables you to see what states are higher or lower in both overdose
              deaths and Medicare Part D opioid prescriptions per patient.</p>

            <p className="lead">
              This visualization allows you to take a closer look and compare the publicly available
              drug overdose death rates data and Medicare Part D opioid prescriptions and claims data.
            </p>

            <ReadMore>
              <p>This map enables you to see two dimensions plotted against each other at a state level.
                More red indicates the state was higher in {this.props.xLabel} while
                more blue indicates the state was higher in {this.props.yLabel}.
                If the state was high in both it will appear medium to dark purple.</p>

              <p>The distribution of states across both dimensions is visualized in the scatterplot on the bottom right
                that also acts as a legend for the map coloring. Each dot on the scatterplot can be highlighted to
                show the corresponding state on the map. You can change the dimensions displayed using the menu
                dropdown <i>(upper left)</i>.</p>
            </ReadMore>
          </Col>
          <Col xs={24} md={18} xl={19}>
            <h2>{this.props.xLabel} vs. {this.props.yLabel}</h2>
            <NationalMap
              showLabels={true}
              titleX={this.props.xLabel}
              titleY={this.props.yLabel}
              dimX={this.props.xField}
              dimY={this.props.yField}
              dict={this.props.dict}
              data={this.props.data}
              onClick={stateId => selectState(stateId)}
            />
          </Col>
        </Row>
        <div className="scatter-wrapper">
          <ScatterPlot
            titleX={this.props.xLabel}
            titleY={this.props.yLabel}
            dimId={this.props.idField}
            dimX={this.props.xField}
            dimY={this.props.yField}
            data={this.props.data}/>
        </div>
      </Card>
    );
  }
}

function mapStoreToProps(store, props) {
  return {
    loading: store.states.loading,
    data: store.states.data,
    dict: store.states.dict,
    idField: store.dimensions.stateKey,
    xField: store.dimensions.xField,
    yField: store.dimensions.yField,
    xLabel: store.dimensions.xLabel,
    yLabel: store.dimensions.yLabel,
    xDesc: store.dimensions.xDesc,
    yDesc: store.dimensions.yDesc
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(mapActions, dispatch)
  }
}

export default connect(mapStoreToProps, mapDispatchToProps)(NationalCard);



// WEBPACK FOOTER //
// ./src/containers/NationalCard.js